module.exports = function (app) {
    "use strict";
    app.controller('pages.clientSelection', ["$state", "$scope", "services", "sessionData","navigation","hook",'storage', function ($state, $scope, services, sessionData, navigation, hook, storage) {
        // Sidebar
        if (!(sessionData && sessionData.employerInfo && sessionData.employerInfo.planAdministrator)) {
            return;
        }
        console.log("why coming here -------",$state);


        if(sessionData.clientNumber){
            delete sessionData.clientNumber
        }
        if(sessionData.hasOwnProperty('cancelledClientHasAgreed')){
            sessionData.cancelledClientHasAgreed = false;
        }



        sessionData.clientSelected =  false;

        localStorage.removeItem('clientNumber');
        localStorage.removeItem('clientSelected');
        $scope.shouldShow = false;


        // Add a temporary filter to navigation that will reject all items.
        navigation.setFilter("clientSelection", function(item) {
            return false;
        }, {
                                 temp: true
                             });
        navigation.setFilter("clientSelectionLogos", function(item) {
            item.state = '.';
            return item;
        }, {
                                 temp: true
                             });
        navigation.setFilter("clientSelectionUser", function (item) {  //jshint ignore line
            //If link has entitlement property
            if (item.filterData && item.filterData.entitlement) {
                if (item.filterData.entitlement === '*') {
                    return true;
                }
                else if(item.id == 'clientSelection' ) {
                     return false;
                }
                // jshint ignore:line
            }
            return true;
        },{
            temp: true
        });
        navigation.addTempFilterToModules(["userTabs"], "clientSelectionUser");
        // Update all navigation modules, to apply the temporary filter to remove all links.
        navigation.addTempFilterToModules(["socialLinksHMHS", "footerLinks", "footerTabsThree","headerTabs"], "clientSelection");
        //navigation.addTempFilterToModules(["logo", "footerLogo"], "clientSelectionLogos");

      navigation.update();


        $scope.groups = {
            orderBy: 'clientNumber',
            reverse: true,
            status: 'All',
            pagination: {
                itemsPerPage: 25,
                page: 1
            },
            titles: [
                {
                    name: "Client Name",
                    dataKey: "clientName"

                },
                {
                    name: "Client Number",
                    dataKey: "clientNumber"
                },
                {
                    name: "Client Status",
                    dataKey: "clientStatus"
                }
            ],
            rows:[],
            customFilter : function(group){
                var rback = ($scope.groups.status==='All' || group.clientStatus === $scope.groups.status);
                if($scope.groups.searchClient && $scope.groups.searchClient !== undefined){
                    rback = ((group.clientName.indexOf($scope.groups.searchClient) >= 0 || group.clientName.toLowerCase().indexOf($scope.groups.searchClient.toLowerCase()) >= 0)  && ($scope.groups.status==='All' || group.clientStatus === $scope.groups.status));
                }
                else if($scope.groups.searchNumber && $scope.groups.searchNumber !== undefined){
                    rback = ((group.clientNumber.indexOf($scope.groups.searchNumber) >= 0 || group.clientNumber.toLowerCase().indexOf($scope.groups.searchNumber.toLowerCase()) >= 0) && ($scope.groups.status==='All' || group.clientStatus === $scope.groups.status));
                }
                return rback;
                //|| ((!$scope.groups.searchNumber || group.clientName.indexOf($scope.groups.searchNumber) >= 0 || group.clientName.toLowerCase().indexOf($scope.groups.searchNumber.toLowerCase()) >= 0) && ($scope.groups.status==='All' || group.status === $scope.groups.status)));
            }
        };


        $scope.goToEmployerMode = function (client) {
            //sessionData.basicInfo.loginId = client.clientNumber;
            sessionData.clientNumber = client.clientNumber;
            localStorage.setItem('clientNumber', client.clientNumber);
            localStorage.setItem('clientSelected', true);
            sessionData.isClientselection = false;
            sessionData.clientSelected = true;
            // if(sessionData.employerInfo.planAdministrator){
            //     sessionData.employerInfo.planAdministrator.company = client.clientName;
            // }
            hook.execute("eBusinessSessionStart").then(function (response) {
                //event.preventDefault();
                $state.go("home",null, {
                    location: 'replace'
                });

                // Reserved for future use
            });

        }

        var populateStubArray = function() {
            alert('populateStubArray is not ready')
        }
        var useStub = false;
        //$scope.sidebar.breadCrumb.primary.title = 'Groups for ' + sessionData.employerInfo.planAdministrator.company;
        var handleServiceSuccess = function(retObj, theCaller) {
            $scope.getGroupsSvcIsRunning = false;
            if (retObj && retObj.data && retObj.data.payload && retObj.data.payload) {
                $scope.serviceReturnedItems = true;
                var theGroups = retObj.data.payload
                if (theGroups.length > 0) {
                    $scope.groups.rows = theGroups;
                } else {
                    alert("The service returned no groups.")
                }
            } else {
                alert("The service returned something unexpected.");
            }
        }
        var handleServiceFailure = function(err, theCaller) {
            $scope.getGroupsSvcIsRunning = false;
            if (err.data && err.data.baseMessage && err.data.baseMessage.returnCodeDescription) {
                console.error(err.data.baseMessage.returnCodeDescription)
                console.error('No items found for service = ' + theCaller);
            } else {
                alert("We are unable to process the request right now, Please try again later.");
            }
        }

        var getItemsFromService = function() {
            $scope.groups.pagination.page = 1;
            $scope.getGroupsSvcIsRunning = true;
            if (useStub) {
                populateStubArray();
                return;
            }
            // to pass bpdId based brand
            if(sessionData && sessionData.employerInfo && sessionData.employerInfo.planAdministrator && sessionData.employerInfo.planAdministrator.dataDifferentiator){
                $scope.bpdId = sessionData.employerInfo.planAdministrator.dataDifferentiator;
            }
            services.eprsvc.mcuClients().fetch(sessionData.employerInfo.planAdministrator.userId, $scope.bpdId).then(function (retObj) {
                $scope.shouldShow = true;
                handleServiceSuccess(retObj);
            }, function (err) {
                $scope.shouldShow = true;
                handleServiceFailure(err);
            });
        }
        setTimeout(function() {
            getItemsFromService();
        },0);


    }]);

    return [
        {
            state: "clientselection",
            url: "/client-selection",
            postPassword: true,
            views: {
                'body@': {
                    template: bootstrap.templates['page-templates/hmhs/landing-page.html'],
                    controller: 'pages.clientSelection'
                },
                "dashboard@clientselection": {
                    templateUrl: "client-selection.employerTemplate.html/pages/mcuClientSelection/mcuClientSelection"
                } } }

    ];
};

